import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, StarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-gradient-to-b from-warmWhite to-cream py-20 px-4" data-id="element-209">
      <motion.div className="max-w-4xl mx-auto" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} data-id="element-210">
        <div className="relative bg-gradient-to-br from-terracotta-50 to-sage-50 rounded-3xl p-8 sm:p-12 shadow-warm-lg border border-terracotta-100" data-id="element-211">
          {/* Decorative elements */}
          <div className="absolute top-6 right-6 text-terracotta-200" data-id="element-212">
            <MoonIcon className="w-8 h-8" data-id="element-213" />
          </div>
          <div className="absolute bottom-6 left-6 text-sage-200" data-id="element-214">
            <StarIcon className="w-6 h-6" data-id="element-215" />
          </div>
          <div className="absolute top-12 left-12 text-sage-100" data-id="element-216">
            <StarIcon className="w-4 h-4" data-id="element-217" />
          </div>

          <div className="relative text-center" data-id="element-218">
            <div className="w-1 h-12 bg-terracotta-300 mx-auto mb-6 rounded-full" data-id="element-219" />

            <p className="font-heading text-2xl sm:text-3xl text-charcoal leading-relaxed mb-6" data-id="element-220">
              En los próximos 7 días, pasarás de despertares cada 45 minutos a{' '}
              <span className="text-terracotta font-semibold" data-id="element-221">
                bloques de 4 horas de sueño ininterrumpido
              </span>
              .
            </p>

            <p className="font-body text-lg text-warmGray leading-relaxed mb-6" data-id="element-222">
              No es magia, es neurobiología aplicada al descanso infantil.
            </p>

            <p className="font-heading text-xl text-charcoal italic" data-id="element-223">
              Empezarás a sentir que recuperas tu energía, tu paciencia y, sobre
              todo, tu{' '}
              <span className="text-sage font-semibold" data-id="element-224">
                felicidad como madre
              </span>
              .
            </p>

            <div className="w-1 h-12 bg-terracotta-300 mx-auto mt-6 rounded-full" data-id="element-225" />
          </div>
        </div>
      </motion.div>
    </section>;
}